<div (click)="onClose()" class="lightbox">
  <div (click)="$event.stopPropagation()" class="lightbox-content">
    @if (images.length > 1) {
      <div (click)="showPreviousImage()" [class.disabled]="isPreviousDisabled()" class="prev-btn button lg">
        <app-icon [cssStyle]="{ 'margin-left': '-2px', 'margin-top': '2px' }" [planeIcon]="true" color="var(--text-color-light)" iconName="chevron-left" size="16px"></app-icon>
      </div>
    }
    <img (click)="openUrlInNewTab()" [src]="currentImageUrl" alt="Image" appDefaultImage loading="lazy" />

    @if (images.length > 1) {
      <div (click)="showNextImage()" [class.disabled]="isNextDisabled()" class="next-btn button lg">
        <app-icon [cssStyle]="{ 'margin-right': '-2px', 'margin-top': '2px' }" [planeIcon]="true" color="var(--text-color-light)" iconName="chevron-right" size="16px"></app-icon>
      </div>
    }
  </div>

  <div (click)="$event.stopPropagation(); onClose()" class="close-btn button sm">
    <app-icon [cssStyle]="{ 'margin-top': '1px' }" [planeIcon]="true" color="var(--text-color-light)" iconName="close" size="16px"></app-icon>
  </div>

  <div class="delete-save-buttons">
    @if (images.length > 1) {
      <div class="button sm">
        <app-icon [cssStyle]="{ 'margin-top': '1px' }" [planeIcon]="true" color="var(--text-color-light)" iconName="trash-bin" size="16px"></app-icon>
      </div>
    }

    <div (click)="$event.stopPropagation(); downloadImage(currentImageUrl)" class="button sm">
      <app-icon [cssStyle]="{ 'margin-top': '1px' }" [planeIcon]="true" color="var(--text-color-light)" iconName="save" size="16px"></app-icon>
    </div>
  </div>
</div>
